import React from "react";
import { Fade, Zoom } from "react-reveal";

import data from "./Future.data";

const Future = () => {
  return (
    <Fade cascade duration={1000}>
      <section
        className={`container mx-auto px-6 sm:px-6 md:px-0 lg:px-4 xl-px-16 mb-20 py-4 my-[50px]`}
      >
        <div className="text-center">
          <h1 className={`Secondheading font-bold`}>How Our Future Looks</h1>
        </div>
        <div className="container mx-auto md:grid gap-4 grid-cols-2 lg:flex justify-center sm:mt-[40px] mt-[50px]">
          {data.map((data, index) => (
            <div
              key={index}
              className="lg:flex md:items-center mb-8 w-[267px] h-[190px] sm:w-[267px] sm:h-[220px] md:w-[365px] md:h-[210px] mx-auto md:mx-2"
            >
              <div
                className={`${
                  data?.text == "coming soon"
                    ? "border border-[#B9B9B9]"
                    : "bg-[#FFFFFF] border-[2px] border-[#5463FF]"
                }  rounded-[12px]   p-5 shadow  w-full h-[190px]`}
              >
                <div className="py-4 flex items-center justify-between ">
                  <img src={data?.icon} alt="" />
                  <p className="text-base text-blue">{data?.text}</p>
                </div>
                <p
                  className={`text-[14px] sm:text-[16px] md:text-base ${
                    data?.id == 3 ? "text-[#161616]" : "text-[#161616]"
                  } `}
                >
                  {data?.title}
                </p>
                <p className="text-[14px] sm:text-[16px] md:text-base text-[#161616]">
                  {data?.title2}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Fade>
  );
};

export default Future;
